import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { DropdownComponent, TextRadioComponent } from 'core/components/Form';

import { VariantDescriptionComponent } from './VariantDescriptionComponent';

export const VariantComponent = (props) => {
	if (!props.variant.values) return null;

	const selectedVariantValueName = props.value;
	const selectedVariantValue = props.variant.values.find((value) => value.name === selectedVariantValueName);

	if (!props.useDropdown) {
		return (
			<Fragment>
				<TextRadioComponent
					className={props.className}
					id={props.id}
					name={`variant-${props.variant.id}`}
					label={props.variant.name}
					value={props.value}
					options={props.variant.values.filter((val) => val.name.length > 0).map((val) => ({ display: val.name, value: val.name }))}
					onChange={props.onValueChange}
					tight
				/>
				<VariantDescriptionComponent description={selectedVariantValue.description} />
			</Fragment>
		);
	} else {
		return (
			<Fragment>
				<DropdownComponent
					className={props.className}
					id={props.id}
					name={`variant-${props.variant.id}`}
					label={props.variant.name}
					value={props.value}
					options={props.variant.values.filter((val) => val.name.length > 0).map((val) => ({ display: val.name, value: val.name }))}
					onChange={props.onValueChange}
					tight
				/>
				<VariantDescriptionComponent description={selectedVariantValue.description} />
			</Fragment>
		);
	}
};

const VariantValuePropTypes = PropTypes.shape({
	description: PropTypes.string,
	id: PropTypes.number,
	name: PropTypes.string,
	type: PropTypes.string
});

export const VariantPropTypes = PropTypes.shape({
	id: PropTypes.number,
	name: PropTypes.string,
	values: PropTypes.arrayOf(VariantValuePropTypes),
	enabled: PropTypes.bool,
});

VariantComponent.propTypes = {
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	variant: VariantPropTypes,
	onValueChange: PropTypes.func,
	value: PropTypes.any,
	useDropdown: PropTypes.bool,
	className: PropTypes.string,
};

VariantComponent.defaultProps = {
	useDropdown: false,
};
